
const SET_PAPEIS_SEGURANÇA = 'SET_PAPEIS_SEGURANÇA'

export default {
  namespaced: true,
  state: {
    tipoPapeisSeguranca: [],
    papeisSelecionados: []
  },
  getters: {
    getTipoPapeisSeguranca: (state) => state.tipoPapeisSeguranca,
  },
  mutations: {
    [SET_PAPEIS_SEGURANÇA] (state, data) {
      state.tipoPapeisSeguranca = data
    },
  },
  actions: {
    setTiposPapeisSeguranca ({ commit }, data) {
      commit(SET_PAPEIS_SEGURANÇA, data)
    },
  }
}



